import axios, {
  AxiosRequestConfig,
  AxiosError,
  InternalAxiosRequestConfig,
} from 'axios';

let accessToken: string = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2NDQ2NDgwYy1kMTM3LTQwYzMtYWNhMi1lZjQ5MWQ2MTFiYmEiLCJpYXQiOjE3NDUzODk0NzYsImV4cCI6MTc0NTQ3NTg3NiwiYXVkIjoidXNlciIsImp0aSI6IjIxYmE1MWM0LTA0OGUtNDJlNi1iMWQ1LTVkODEwYzlhYWU1ZCJ9._XVGyqB2z0abIneVGMM3hUKNVKts5t2cO4RsOfchfJk';

const api = axios.create({
  baseURL: `https://api.dev.wallet.haqqex.tech/api/v1/bonusTree/`,
  headers: {
    Authorization: `Bearer ${accessToken}`,
    'x-app-version': '1.19',
  },
});

let isRefreshing = false;
let failedQueue: {
  resolve: (token: string) => void;
  reject: (error: Error) => void;
}[] = [];

const processQueue = (error: Error | null, token: string | null = null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (token) {
      resolve(token);
    } else if (error) {
      reject(error);
    }
  });
  failedQueue = [];
};

const rnMessageHandler = (event: MessageEvent) => {
  let message: { type?: string; data?: any } | null = null;

  try {
    message = JSON.parse(event?.data);
  } catch (e) {
    return;
  }

  switch (message?.type) {
    case 'setAccessToken':
      if (typeof message.data === 'string') {
        accessToken = message.data;
        api.defaults.headers.Authorization = `Bearer ${accessToken}`;
        processQueue(null, accessToken);
      }
      break;
  }
};

window.addEventListener('message', rnMessageHandler);
(document as any).addEventListener('message', rnMessageHandler);

api.interceptors.request.use((req: InternalAxiosRequestConfig) => req);

api.interceptors.response.use(
  res => res,
  async (error: AxiosError) => {
    const originalRequest = error.config as AxiosRequestConfig & {
      _retry?: boolean;
    };

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise<string>((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers = {
              ...originalRequest.headers,
              Authorization: `Bearer ${token}`,
            };
            return api(originalRequest);
          })
          .catch(err => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      (window as any).ReactNativeWebView?.postMessage(
        JSON.stringify({ type: '401' }),
      );

      return new Promise<string>((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then(token => {
          originalRequest.headers = {
            ...originalRequest.headers,
            Authorization: `Bearer ${token}`,
          };
          return api(originalRequest);
        })
        .catch(err => Promise.reject(err))
        .finally(() => {
          isRefreshing = false;
        });
    }

    return Promise.reject(error);
  },
);

export const postMapper =
  <Req, Res>(url: string) =>
  async (data: Req, config?: AxiosRequestConfig): Promise<Res> => {
    return (await api.post<Res>(url, data, config)).data;
  };

export const getMapper =
  <Par, Res>(url: string) =>
  async (params: Par, config?: AxiosRequestConfig): Promise<Res> => {
    return (await api.get<Res>(url, { ...config, params })).data;
  };

export default api;
